import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    home: false
}


const homeButtonSlice = createSlice({
    name: 'homeButtonSlice',
    initialState: initialState,
    reducers: {
        updateHomeButton(state, action) {
            state.home = action.payload;
        },

    },
});

export const { updateHomeButton } = homeButtonSlice.actions;

export default homeButtonSlice.reducer;
